import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {CARD_LOGOS} from '../../../consts';
import {pushFormTrackingEvent} from '../MicroformField/push-form-tracking-event';

class CybersourceCardNumberField extends React.Component {
    microformField = null

    componentWillReceiveProps(nextProps) {
        if (this.microformField === null && nextProps.microformField !== null) {
            this.microformField = nextProps.microformField;
            this.microformField.on('change', this.onChange);
            this.microformField.on('blur', this.onBlur);
        }
    }

    componentWillUnmount() {
        if (this.microformField) {
            this.microformField.off('change', this.onChange);
            this.microformField.off('blur', this.onBlur);
        }
    }

    onBlur = () => {
        const {form: {setFieldTouched}, field: {name}} = this.props;
        pushFormTrackingEvent(name);
        setFieldTouched(name, true);
    }

    onChange = data => {
        const {form: {setFieldValue}, field: {name}} = this.props;
        setFieldValue(name, data);
    }

    render() {
        const {
            id,
            field: {value: {card = []}},
            featureFlags
        } = this.props;
        const type = card.find(x => x.couldBeValid)?.name ?? '';
        return (
            <div className="card-number-wrapper">
                <div id={id} className="flex-microform" />
                {featureFlags.cardTypeIcon.enabled && (
                    <img
                        className="card-number-icon"
                        src={CARD_LOGOS[type] || CARD_LOGOS.cybersourceOther}
                        alt="card number input"
                    />
                )
                }
            </div>
        );
    }
}

CybersourceCardNumberField.getInitialFieldValues = () => ({
    empty: true,
    valid: false
});

CybersourceCardNumberField.defaultProps = {
    microformField: null
};

CybersourceCardNumberField.propTypes = {
    id: PropTypes.string.isRequired,
    microformField: PropTypes.shape(),
    field: PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.shape({
            card: PropTypes.arrayOf(PropTypes.shape({
                couldBeValid: PropTypes.bool.isRequired,
                name: PropTypes.string.isRequired
            }))
        }).isRequired
    }).isRequired,
    form: PropTypes.shape({
        setFieldValue: PropTypes.func.isRequired,
        setFieldTouched: PropTypes.func.isRequired
    }).isRequired
};

const mapStateToProps = ({featureFlags}) => ({
    featureFlags
});

const ConnectedCybersourceCardNumberField = connect(mapStateToProps)(CybersourceCardNumberField);

export default ConnectedCybersourceCardNumberField;
